import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
const includedItems = ['7 Complete Professional Volumes', '150 Ready-to-Run Sessions', '5 High-Value Bonus Guides', 'Beginner to Advanced', 'Immediate Access', 'PDF Format', '7-Day Guarantee', 'Pay in Your Local Currency'];
const releases = ['No more hours searching for drills', 'No more disconnected exercises without progression', 'No more rebuilding competition weeks from zero', 'No more wondering what to coach next', 'No more repeating the same sessions because they’re the only ones ready'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-mist-light relative overflow-hidden" data-id="element-108" data-mp="qvf1vofx1a6p">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-109" data-mp="14v6htupzt0nc">
        <div className="text-center mb-16" data-id="element-110" data-mp="14vpp8hi0o6n4">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-navy" data-id="element-111" data-mp="zwvabqn6728a">
            Next Week You Can Keep Building Every Session From Scratch...
            <br data-id="element-112" data-mp="2c712k0ez8tvx" />
            <span className="text-gold-solid" data-id="element-113" data-mp="2h3hnymusku5b">
              Or You Can Walk Onto the Track With Your Coaching System Already Ready.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-mist-dark shadow-sm" data-id="element-114" data-mp="2m4xa6i8ph6pa">
            {releases.map(item => <div key={item} className="flex items-start gap-3" data-id="element-115" data-mp="2v2r3dkb6bk88">
                <span className="text-gold-dark mt-1" data-id="element-116" data-mp="3023pu3y4upaa">▸</span>
                <span className="text-slate" data-id="element-117" data-mp="300itq9w66yab">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-slate mb-16" data-id="element-118" data-mp="34voev6hr08xc">
            Track &amp; Field Coach Ready gives you the structure and tools to make your
            coaching easier to organize and more consistent to deliver.
          </p>
        </div>

        <div className="bg-white border-2 border-gold/60 rounded-3xl p-8 md:p-12 shadow-[0_16px_40px_rgba(15,42,82,0.12)]" data-id="element-119" data-mp="3isbpgc2mixlq">
          <h3 className="text-2xl font-bold text-navy mb-6 text-center border-b border-mist-dark pb-6" data-id="element-120" data-mp="1jp4rnj7tonk6">
            Everything Included
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-121" data-mp="1sgevq4gh0234">
            {includedItems.map(item => <div key={item} className="flex items-center gap-3" data-id="element-122" data-mp="1npez70b9jm15">
                <Check size={18} className="text-success shrink-0" data-id="element-123" data-mp="1no3vf0htiea1" />
                <span className="text-sm text-slate" data-id="element-124" data-mp="22d9tum8u00gv">{item}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-125" data-mp="1xhuhxzudwen3">
            <div className="mb-8 p-6 bg-mist rounded-xl border border-mist-dark italic text-slate text-lg" data-id="element-126" data-mp="2bg18eux07ccq">
              “The best time to have a complete coaching system was before your athletes
              needed it.
              <br data-id="element-127" data-mp="h2jfsthqrpau" />
              <span className="text-navy font-bold not-italic" data-id="element-128" data-mp="h20783dzed9h">
                The second best time is today.
              </span>
              ”
            </div>
            <p className="text-xl font-serif font-bold text-navy mb-2" data-id="element-129" data-mp="2vpyvp0gmygl">
              📚 Track &amp; Field Coach Ready
            </p>
            <p className="text-sm text-slate mb-8" data-id="element-130" data-mp="6wryw827bejm">
              150 ready-to-run Track &amp; Field coaching sessions designed to help you plan
              less, coach with more structure and develop athletes with a complete system.
            </p>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-lg md:text-xl py-5 px-10 mb-6" data-id="element-131" data-mp="3fcv8ijcvjdal">
              🟡 GET THE COMPLETE TRACK &amp; FIELD COACHING SYSTEM NOW
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-slate" data-id="element-132" data-mp="3bbrt1xyqnj9w">
              <span data-id="element-133" data-mp="3bdmdlb63l9dg">✅ 7-Day Guarantee</span>
              <span data-id="element-134" data-mp="14l238tpgmedw">✅ Secure Payment</span>
              <span data-id="element-135" data-mp="14j8un8vadk39">✅ Immediate Access</span>
              <span data-id="element-136" data-mp="19ky6gqqc21se">✅ PDF Format</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}